// extracted by mini-css-extract-plugin
export default {"menu":"kWnej","tab":"aCoBK","selected":"yASUb"};